import { useState } from "react";

import { Input } from "@/components/ui/input";

import { FILTER_CONTROL_CLASS } from "../constants";
import { trimmedOrUndefined } from "../utils/filter-input";

interface TextFilterProps<Key extends string> {
  filterKey: Key;
  placeholder: string;
  applied: string | undefined;
  normalize?: (typed: string) => string | undefined;
  onApply: (key: Key, value: string | undefined) => void;
}

const ENTER_KEY: string = "Enter";

export default function TextFilter<Key extends string>({
  filterKey,
  placeholder,
  applied,
  normalize = trimmedOrUndefined,
  onApply,
}: TextFilterProps<Key>): JSX.Element {
  const [typed, setTyped] = useState<string>(applied ?? "");
  const apply = (): void => onApply(filterKey, normalize(typed));

  return (
    <Input
      type="text"
      aria-label={placeholder}
      placeholder={placeholder}
      value={typed}
      onChange={e => setTyped(e.target.value)}
      onBlur={apply}
      onKeyDown={e => e.key === ENTER_KEY && apply()}
      className={`w-full ${FILTER_CONTROL_CLASS}`}
    />
  );
}
